// components/ProductCard.jsx
import GetViews from '@components/GetViews';
import Comments from '@components/Comments';
import { BREED_ALL } from '@/constants/breeds';

export default function ProductCard({ product, onRequestDelete }) {
  const priceText =
    product?.price != null
      ? typeof product.price === 'number'
        ? product.price.toFixed(2)
        : product.price
      : '';

  return (
    <div className='col-lg-4 col-xl-12'>
      <div className='card'>
        <div className='card-body'>
          <div className='row m-b-30'>
            <div className='col-md-5 col-xxl-12'>
              <div className='new-arrival-product mb-4 mb-xxl-4 mb-md-0'>
                <div className='new-arrivals-img-contnent'>
                  <img
                    className='img-fluid'
                    src={product.avatar}
                    alt={product.product || 'Product'}
                  />
                </div>
              </div>
            </div>

            <div className='col-md-7 col-xxl-12'>
              <div className='new-arrival-content position-relative'>
                <h4 className='mb-1'>
                  <a
                    href={product.externalUrl || '#'}
                    target={product.externalUrl ? '_blank' : undefined}
                    rel={
                      product.externalUrl ? 'noopener noreferrer' : undefined
                    }
                  >
                    {product.product}
                  </a>
                </h4>

                <div className='comment-review star-rating'>
                  <ul>
                    <li>
                      <i className='fa fa-star' />
                    </li>
                    <li>
                      <i className='fa fa-star' />
                    </li>
                    <li>
                      <i className='fa fa-star' />
                    </li>
                    <li>
                      <i className='fa fa-star' />
                    </li>
                    <li>
                      <i className='fa fa-star-half-empty' />
                    </li>
                  </ul>
                  <span className='review-text'>(34 reviews)</span>
                </div>

                <p className='mb-1'>
                  <span className='price'>${priceText}</span>
                </p>
                <p className='mb-1'>
                  Category:{' '}
                  <span className='item'>
                    {product.categoryName}
                    {product.subCategoryName ? (
                      <> - {product.subCategoryName}</>
                    ) : null}
                  </span>
                </p>

                {product.breeds?.length ? (
                  <p className='mb-1'>
                    Breeds:{' '}
                    {product.breeds[0] === BREED_ALL ? (
                      <span className='badge bg-light text-dark border'>
                        All Breeds
                      </span>
                    ) : (
                      product.breeds.map((b) => (
                        <span
                          key={b}
                          className='badge bg-light text-dark border me-1'
                        >
                          {b}
                        </span>
                      ))
                    )}
                  </p>
                ) : null}

                {product.geography?.length ? (
                  <p className='mb-1'>
                    Geography:{' '}
                    {product.geography.map((g) => (
                      <span
                        key={g}
                        className='badge bg-light text-dark border me-1'
                      >
                        {g}
                      </span>
                    ))}
                  </p>
                ) : null}

                {product.description && (
                  <p className='text-content mb-0'>{product.description}</p>
                )}
              </div>

              <div className='card-footer bg-transparent border-0 px-0'>
                <div className='row row-cols-3 g-2 mt-2'>
                  <div className='col d-flex justify-content-center'>
                    <GetViews
                      docPath={`marketplace/${product.id}`}
                      buttonSize='xs'
                    />
                  </div>
                  <div className='col d-flex justify-content-center'>
                    <Comments
                      parentId={product.id}
                      collectionPath='marketplace'
                      showCommentLabel={false}
                    />
                  </div>
                  <div className='col d-flex justify-content-center'>
                    <div className='tooltip-container'>
                      <button
                        type='button'
                        className='reaction-btn reaction-action'
                        title={`Delete ${product.product}`}
                        data-bs-toggle='modal'
                        data-bs-target='#confirmDelete'
                        onClick={(e) => {
                          e.preventDefault();
                          onRequestDelete(product);
                        }}
                      >
                        <i className='fas fa-trash reaction-icon' />
                      </button>
                      <span className='tooltip'>Delete {product.product}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* right */}
          </div>
        </div>
      </div>
    </div>
  );
}
